module.exports = __webpack_public_path__ + "static/media/mainChart1ForError4.2f232cc0.png";